export const adminSidebarData = [
    {
        itemName: 'ダッシュボード',
        itemUrl: '/admin-dashboard',
        subItems: []
    },
    {
        itemName: 'マスタデータ',
        itemUrl: '',
        subItems: [
            {
                itemName: '国一覧',
                itemUrl: '/countries'
            },
            {
                itemName: '支社一覧',
                itemUrl: '/branches'
            },
            {
                itemName: '部署一覧',
                itemUrl: '/departments'
            },
            {
                itemName: '役割一覧',
                itemUrl: '/roles'
            },
            {
                itemName: '技術一覧',
                itemUrl: '/technologies'
            },
            {
                itemName: '担当規模一覧',
                itemUrl: '/responsibilities'
            },
        ]
    },
    {
        itemName: 'ユーザ一覧',
        itemUrl: '/users',
        subItems: []
    },
    {
        itemName: 'プロジェクト',
        itemUrl: '/projects',
        subItems: []
    },
];
